import React, { useCallback, useEffect, useMemo } from "react";
import { TransferDownload } from "@ui-kit/components/index.es";
import { bool, func } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { push } from "react-router-redux";

import { resizableRoute } from "pages/_components/Resizable";

import { actions as transferActions, selectors as transferSelectors } from "reducers/transfer";
import { actions as layoutActions } from "reducers/layout";

import * as config from "util/config";
import * as i18n from "util/i18n";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { getTransferHistoricPath } from "util/v3UxConfig";
import {
    formatTransferDownloadDateLocal,
    getTransferDownloadDateWindow,
    getTransferDownloadLabels,
} from "v3/pages/transfers/transferDownload";

function TransferDownloadV3Page(props) {
    TransferDownloadV3Page.propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
    };

    const { dispatch, isDesktop, fetching } = props;
    const { minDate, maxDate, initialDateRange } = useMemo(() => getTransferDownloadDateWindow(), []);
    const goBackPath = getTransferHistoricPath();
    const title = i18n.get("transfers.historic.download.title");
    const hintText = config.get("frontend.Transfers.Download.Message");

    const handleBack = useCallback(() => {
        dispatch(push(goBackPath));
    }, [dispatch, goBackPath]);

    const handleDownload = useCallback(
        (format, dateFrom, dateTo) => {
            dispatch(
                transferActions.downloadTransfersHistoric(
                    formatTransferDownloadDateLocal(dateFrom),
                    formatTransferDownloadDateLocal(dateTo),
                    format,
                ),
            );
        },
        [dispatch],
    );

    useEffect(() => {
        if (!isUxDashboardImprovementsEnabled()) {
            return undefined;
        }
        dispatchV3ShellLayout(dispatch, {
            titleKey: !isDesktop ? "transfers.historic.download.title" : "",
            goBackPath: !isDesktop ? goBackPath : null,
            scopes: ["form"],
        });
        return () => {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        };
    }, [dispatch, goBackPath, isDesktop]);

    return (
        <TransferDownload
            goBack={handleBack}
            title={title}
            hintText={hintText}
            getLabels={getTransferDownloadLabels}
            initialDateRange={initialDateRange}
            minDate={minDate}
            maxDate={maxDate}
            onDownload={handleDownload}
            downloadLoading={fetching}
            desktopHeaderMode={isDesktop ? "pageHeader" : "none"}
        />
    );
}

const mapStateToProps = (state) => ({
    fetching: transferSelectors.getFetchingDownload(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(TransferDownloadV3Page);
